import { ReturnToAppPrompt } from '@/components/auth/return-to-app-prompt';
import { ThemedText } from '@/components/themed-text';
import { useAuthStore } from '@/store/authStore';
import { trialDaysRemaining } from '@/utils/trial';
import { useLocalSearchParams } from 'expo-router';
import React, { useEffect } from 'react';
import { Platform } from 'react-native';

export default function PlanSelectedScreen() {
  const { planName } = useLocalSearchParams<{ planName?: string }>();
  const fetchProfile = useAuthStore((s) => s.fetchProfile);
  const trialEndsAt = useAuthStore((s) => s.user?.providerProfile?.trialEndsAt ?? null);

  useEffect(() => {
    if (Platform.OS === 'web') {
      void fetchProfile();
    }
  }, [fetchProfile]);

  const planLabel = typeof planName === 'string' && planName.length > 0 ? planName : 'seu plano';
  const trialDaysLeft = trialDaysRemaining(trialEndsAt);

  return (
    <ReturnToAppPrompt
      title="Parabéns!"
      description={
        <>
          Você selecionou o Plano {planLabel}. Agora você tem{' '}
          <ThemedText className="font-bold text-primary">
            {trialDaysLeft > 0 ? `${trialDaysLeft} dias grátis` : 'seu teste grátis'}
          </ThemedText>{' '}
          para usar a Controlapag com tranquilidade.
        </>
      }
      subtitle="Toque no botão abaixo para voltar ao aplicativo e começar a operar."
      testId="subscription-plan-selected-open-app"
      continueOnWebHref="/(tabs)/(provider)/home"
    />
  );
}
